import {MainVideoState} from "../definitions/MainVideoState";

export const showFullScreen = (state: MainVideoState) => {
    state.projectState.showFullScreen = true;
    state.projectState.showFullScreenControlBar = true;
    state.shouldShowGrid = false;
};
